import { render, staticRenderFns } from "./referrer-list.vue?vue&type=template&id=56822f57"
import script from "./referrer-list.vue?vue&type=script&lang=js"
export * from "./referrer-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports